import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepThreeExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepThreeExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) =>
    state.discoverStepThreeExtraLevels.data.discoverStepThreeExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
